import { useState } from "react";
import { Receipt, Undo2 } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { BillingStatus, billingOf } from "@/lib/reports";
import { fmtDateTime } from "@/lib/format";
import { Panel, SectionLabel } from "@/components/common/ui-kit";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const BillingPanel = ({ rep, onDone }) => {
  const { can } = useAuth();
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ invoice_number: "", invoice_date: new Date().toISOString().slice(0, 10) });
  const [busy, setBusy] = useState(false);
  const st = billingOf(rep);
  if (!st || !can("reports:economics")) return null;
  const send = async (status) => {
    setBusy(true);
    try {
      await api.post(`/service-reports/${rep.id}/billing`, status === "fatturato" ? { status, invoice_number: f.invoice_number.trim(), invoice_date: f.invoice_date || null } : { status });
      toast.success(status === "fatturato" ? "Rapportino segnato come fatturato" : "Rapportino riportato a da fatturare"); setOpen(false); onDone();
    } catch (e) { toast.error(errorMessage(e)); }
    setBusy(false);
  };
  return (
    <Panel className="p-5" data-testid="report-billing-panel">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="space-y-1">
          <SectionLabel>Fatturazione</SectionLabel>
          <div className="flex items-center gap-2"><BillingStatus rep={rep} testId="report-billing-status" />
            {st === "fatturato" && <span className="text-sm text-slate-600" data-testid="report-invoice-info">Fattura <b className="text-ink">{rep.invoice_number}</b> del {rep.invoice_date?.split("-").reverse().join("/")}{rep.invoiced_at ? ` · registrata ${fmtDateTime(rep.invoiced_at)}` : ""}</span>}</div>
        </div>
        {!can("billing:manage") ? null : st === "da_fatturare"
          ? <Button onClick={() => setOpen(true)} className="gap-2" data-testid="report-mark-invoiced"><Receipt className="h-4 w-4" />Segna come fatturato</Button>
          : <Button variant="outline" disabled={busy} onClick={() => send("da_fatturare")} className="gap-2" data-testid="report-unmark-invoiced"><Undo2 className="h-4 w-4" />Riporta a da fatturare</Button>}
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-md" data-testid="report-invoice-dialog">
          <DialogHeader><DialogTitle className="font-display text-xl">Segna come fatturato</DialogTitle>
            <DialogDescription>{rep.number}: indica gli estremi della fattura emessa. I valori economici non cambiano.</DialogDescription></DialogHeader>
          <div className="space-y-3">
            <div className="space-y-1.5"><Label className="text-xs">Numero fattura</Label><Input value={f.invoice_number} maxLength={60} onChange={(e) => setF({ ...f, invoice_number: e.target.value })} data-testid="report-invoice-number" /></div>
            <div className="space-y-1.5"><Label className="text-xs">Data fattura</Label><Input type="date" value={f.invoice_date} onChange={(e) => setF({ ...f, invoice_date: e.target.value })} data-testid="report-invoice-date" /></div>
          </div>
          <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>Annulla</Button>
            <Button disabled={busy || !f.invoice_number.trim()} onClick={() => send("fatturato")} data-testid="report-invoice-save">Conferma fatturazione</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </Panel>
  );
};
